module.exports = __webpack_public_path__ + "img/module-thumb.f63eee9f.jpg";